module.exports = __webpack_public_path__ + "static/media/export.1635ce44.svg";